import dynamic from 'next/dynamic'

import { visuallyHiddenMixin } from '@thg-commerce/gravity-elements'
import { css, styled } from '@thg-commerce/gravity-theme'

const StarIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReviewStar'),
)

const SelectedStarIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ReviewStarSelected'),
)

export const styledStarIconProperties = css`
  width: 14px;
  height: 14px;
`

export const StyledStarIcon = styled(StarIcon)`
  ${styledStarIconProperties}
`

export const StyledSelectedStarIcon = styled(SelectedStarIcon)`
  ${styledStarIconProperties}
`

export const FiveStarsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const TwoStarsContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const OptionRadioLabel = styled.label<{
  selected: boolean
  value: string
}>`
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  min-width: 70px;
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};

  &:hover {
    cursor: pointer;
    border-color: ${(props) =>
      !props.selected && props.theme.colors.palette.greys.grey};
  }

  &:not(:hover) {
    ${(props) =>
      props.value !== '5' && !props.selected && `border-right: 1px solid #fff;`}
  }

  ${(props) =>
    props.selected &&
    `border: 1px solid #D77F04;
     background-color: #D77F04;`}

  ${(props) => props.value === '1' && `border-radius: 4px 0 0 4px;`}

  ${(props) => props.value === '5' && `border-radius: 0 4px 4px 0;`}
`

export const HiddenRadioButton = styled.input`
  ${visuallyHiddenMixin}

  &:focus-visible + ${OptionRadioLabel} {
    border: 2px solid ${(props) => props.theme.colors.palette.brand.base};
    outline: none;
  }
`
